
import { faFileDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DefaultButton from 'components/buttons/DefaultButton/DefaultButton';
import TextInput from 'components/inputs/TextInput/TextInput';
import Spinner from 'components/spinner/Spinner';
import i18n from 'i18n';
import moment from 'moment';
import React, { MutableRefObject, useEffect, useRef, useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDeviceDetect } from 'utils/hooks/deviceDetect';
import useHttp from 'utils/hooks/useHttp';
import { useLocaleDatePicker } from 'utils/localeDatePicker';
import { notify } from '../../../../../utils/marketplace';

type Props = {
  setFilter,
  setForcePage: (forcePage: number) => void;
  loadingExportMobile: boolean;
  setLoadingExportMobile: (e: boolean) => void;
  setIsActive: (e: boolean) => void;

}

const Filter: React.FC<Props> = (props) => {

  const { reset, getValues, register, handleSubmit } = useForm();
  const [openDate, setOpenDate] = useState(false);
  const [loadingExport, setLoadingExport] = useState<boolean>(false);
  const http = useHttp();
  const { t } = useTranslation();
  const dateRef = useRef() as MutableRefObject<HTMLDivElement>;
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(null);
  const [filterStartDate, setFilterStartDate] = useState<string | null>(null);
  const [filterEndDate, setFilterEndDate] = useState<string | null>(null);
  const [valueDate, setValueDate] = useState<string | null>(null);
  const { isMobile } = useDeviceDetect();


  const handleExportFile = () => {

    setLoadingExport(true);
    const data = getValues();

    if (data.order_id === '') {
      delete data.order_id;
    }

    if (data.reference === '') {
      delete data.reference;
    }

    const param = data;

    if (filterStartDate) {
      param['start_date'] = filterStartDate;
    }

    if (filterEndDate) {
      param['end_date'] = filterEndDate;
    }

    http.remainingHttp.exportV3(param).then((data) => {
      const element = document.createElement('a');

      const file = new Blob(
        [data.data],
        { type: data.type },
      );

      element.href = URL.createObjectURL(file);
      element.download = `${t('_financial_export')} - ${moment().format('DD.MM.YYYY')}.xlsx`;
      element.click();
    }).
      catch(() => {
        notify(t('_file_could_not_be_downloaded'));
      })
      .finally(() => {
        setLoadingExport(false);

        if (props.loadingExportMobile) {
          props.setLoadingExportMobile(false);
        }
      });
  };

  const resetFilter = () => {

    setFilterStartDate(null);
    setFilterEndDate(null);
    setValueDate(null);
    setStartDate(new Date());
    setEndDate(null);
    reset({ order_id: '', reference: '' });

    const params = {
      page: 1,
      per_page: 10
    };

    props.setForcePage(1);

    props.setFilter(params);

  };

  function onDateChange(dates) {

    const [start, end] = dates;

    setStartDate(start);
    setEndDate(end);

    if (start && end) {
      setValueDate(`${moment(start).format('YYYY-MM-DD')} - ${moment(end).format('YYYY-MM-DD')}`);
      setFilterStartDate(`${moment(start).format('YYYY-MM-DD')}`);
      setFilterEndDate(`${moment(end).format('YYYY-MM-DD')}`);
    }
    else {

      if (start) {
        setFilterStartDate(`${moment(start).format('YYYY-MM-DD')}`);
        setValueDate(`${moment(start).format('YYYY-MM-DD')}`);

      }

      if (end) {
        setFilterEndDate(`${moment(end).format('YYYY-MM-DD')}`);
        setValueDate(`${moment(end).format('YYYY-MM-DD')}`);

      }
    }
  }

  const onSubmit = async () => {

    props.setForcePage(1);
    props.setIsActive(false);
    const data = getValues();

    if (data.order_id === '') {
      delete data.order_id;
    }

    if (data.reference === '') {
      delete data.reference;
    }

    const param = data;


    if (filterStartDate) {
      param['start_date'] = filterStartDate;
    }

    if (filterEndDate) {
      param['end_date'] = filterEndDate;
    }

    param['page'] = 1;
    param['per_page'] = 10;

    props.setFilter(param);
  };


  useEffect(() => {

    if (props.loadingExportMobile) {
      handleExportFile();
    }

  }, [props.loadingExportMobile]);
  useLocaleDatePicker(i18n.language);

  return (
    <div className="filter">
      <div className="filter-header">
        <div className="filter-link-btn">
          <button className="export-btn" onClick={() => handleExportFile()} disabled={loadingExport}> {loadingExport ? <Spinner class="extra-small" /> : <FontAwesomeIcon icon={faFileDownload} className="icon" />} {t('_export')} </button>
        </div>
        {/* <div className="filter-title">{t('_order_availability')}</div> */}
        <div className="filter-reliquats">

        </div>
      </div>
      <form onSubmit={handleSubmit(() => onSubmit())}>
        <div className="filter-body">

          <div className="filter-input-item">
            <div className={`react-picker-dropdown ${openDate ? 'disable' : ''}`} onClick={() => setOpenDate(true)}>
              <TextInput placeholder={t('_select_date')} defaultValue={valueDate ? valueDate : ''} readOnly />
            </div>
            {openDate && (
              <div className="date-picker" ref={dateRef}>
                <ReactDatePicker
                  dateFormat="YYYY-MM-DD"
                  selected={startDate}
                  onChange={onDateChange}
                  startDate={startDate}
                  endDate={endDate}
                  monthsShown={isMobile ? 1 : 2}
                  selectsRange
                  inline
                  onClickOutside={() => setOpenDate(false)}
                  locale={i18n.language.split('-')[0]}

                />
              </div>
            )}
          </div>
          <div className="filter-input-item">
            <TextInput {...register('order_id')} placeholder={t('_order_id')} />
          </div>
          <div className="filter-input-item">
            <TextInput {...register('reference')} placeholder={t('_reference')} />
          </div>

          <DefaultButton text={t('_filter')} type="submit" />
          <DefaultButton text={t('_reset')} red onClick={() => { resetFilter(); props.setIsActive(false); }} type="button" />
        </div>
      </form>
    </div>
  );
};

Filter.displayName = 'Filter';

export default Filter;
